import { Navigate, Outlet, useLocation } from "react-router";

import { useAuth } from "@/hooks/useAuth";

/**
 * Guard de rutas privadas.
 *
 * Mientras GET /api/user está en vuelo mostramos un loader: sin esto,
 * redirigiríamos a /login ANTES de saber si hay sesión (parpadeo al recargar
 * una ruta protegida ya autenticada).
 *
 * Sin sesión → /login, recordando el destino en `location.state.from` para
 * volver ahí tras el login (deep-linking: la URL identifica el recurso, no un
 * paso del flujo).
 */
export function ProtectedRoute() {
  const { isAuthenticated, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="flex h-screen items-center justify-center">
        <span
          className="border-primary h-6 w-6 animate-spin rounded-full border-2 border-t-transparent"
          role="status"
          aria-label="Cargando"
        />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <Outlet />;
}
